import { render } from "./Errorpage.vue?vue&type=template&id=e29288c2&scoped=true"
import script from "./Errorpage.vue?vue&type=script&lang=js"
export * from "./Errorpage.vue?vue&type=script&lang=js"

import "./Errorpage.vue?vue&type=style&index=0&id=e29288c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e29288c2"

export default script